module.exports = __webpack_public_path__ + "img/6_103.e38f2406.png";